var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-smooth/~/lodash/_Symbol.js
// module id = 944
// module chunks = 0